import { z } from 'zod';

export const createSuperAdminSchema = z.object({
  email: z.string().min(1, 'Email is required').email('Invalid email'),
  firstName: z.string().min(1, 'First name is required'),
  lastName: z.string().min(1, 'Last name is required'),
  password: z.string().min(8, 'Password must be at least 8 characters'),
});

export type CreateSuperAdminFormData = z.infer<typeof createSuperAdminSchema>;
